export default __webpack_public_path__ + "static/media/SurfaceGo.4a67fea8.svg";